import { Overlays } from 'components/ui/overlays';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const DiscardTeamOverlay = ({ handleDiscardTeamOverlay }) => {
  const navigate = useNavigate();
  return (
    <>
      <Overlays
        overlayName={'selectionTeam'}
        overlayConfig={{
          noOverlayHead: true,
          overlayCloseConfig: true,
          noOverlayClose: false,
          noOverlayBody: true,
          noOverlayFoot: true,
          noOverlayReset: false,
          submitBtn: true,
          cancelBtn: true,
          btnSecondary: 'Yes',
          btnPrimary: 'No',
          title: 'BACK TO HOME',
          titleTransKey: 'overlay_title_warning',
          //   caption: 'You already already created a team for this match.',
          captionTransKey: 'overlay_warning_caption_0',

          onCancelClick: () => {
            handleDiscardTeamOverlay(false);
            navigate('/');
          },
          onConfirmClick: () => {
            handleDiscardTeamOverlay(false);
          }
        }}
      >
        Are you sure you want to back? You may loose all your progress.
      </Overlays>
    </>
  );
};

export default DiscardTeamOverlay;
